import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Svg, Typography } from '@altermaind/web/ui';
import { Routes } from '@/_shared/constants/routes';

type Props = {
  onClose: () => void;
};

export const SuccessContent: FC<Props> = ({ onClose }) => {
  const t = useTranslations('core.dialogContacts.success');

  const handleGoToHomepage = () => {
    onClose();
    window.location.href = Routes.Homepage;
  };

  return (
    <Box display='flex' flexDirection='column' alignItems='center'>
      <Box
        display='flex'
        flexDirection='row'
        flex={0}
        borderRadius={100}
        bg='success'
        p='xxs'
        size='xxl'
        mb='m'
      >
        <Svg name='check' size='l' fill='white' />
      </Box>
      <Typography variant='h3' color='primary/text' textAlign='center' mt='none'>
        {t('title')}
      </Typography>
      <Box mt='xs' mb='l'>
        <Typography variant='p2/light' textAlign='center' color='grey/light'>
          {t('description')}
        </Typography>
      </Box>
      <Box display='flex' flexDirection='row' style={{ gap: 16 }}>
        <Button variant='link/primary' onClick={onClose}>
          {t('close')}
        </Button>
        <Button variant='primary' onClick={handleGoToHomepage}>
          {t('cta')}
        </Button>
      </Box>
    </Box>
  );
};
